(function () {
    'use strict';

    angular.module('app').component('newsItems', {
        templateUrl: '@/news/news-items.html',
        restrict: 'E',
        bindings: {
            appName: '@',
            languageCode: '@',
            types: '@',
            searchable: '<',
            mode: '@',
            collapsible: '<',
            onReady: '&?'
        },
        controller: NewsItemsController
    });

    NewsItemsController.$inject = ['webApiServices', 'translationsService', 'notificationService', 'loadingIndicatorService'];
    function NewsItemsController(webApiServices, translationsService, notificationService, loadingIndicatorService) {
        const $controller = this;

        // Initialize scope
        $controller.loading = true;
        $controller.Search = Search;
        $controller.searchText = '';
        $controller.$onInit = initialize;

        function initialize() {
            // Load translations + title
            translationsService.loadTranslations((translations) => {
                $controller.translations = translations;

                SetTitle();
            });

            Search();
        }

        function SetTitle() {
            switch ($controller.types) {
                case 'Manual':
                    $controller.title = $controller.translations.Manual_Title;
                    break;
                case 'Faq':
                    $controller.title = $controller.translations.Faq_Title;
                    break;
                case 'Directive':
                    $controller.title = $controller.translations.Directive_Title;
                    break;
                default:
                    $controller.title = $controller.translations.News_Title;
                    break;
            }
        }

        // Implementation
        function Search() {
            $controller.loading = true;

            const parameters = {
                App: $controller.appName,
                LanguageCode: $controller.languageCode,
                Keywords: $controller.searchText,
                Type: $controller.types
            };

            loadingIndicatorService.SetLoadingState(true);
            const apiCall = $controller.mode === 'ByRole' ? webApiServices.GetNewsItemsByAppsAndRoles : webApiServices.GetPublicNewsItemsByApps;

            apiCall({ Filter: parameters },
                (result) => {
                    if (!CheckResultReceived(result))
                        return;
                    $controller.news = result.data;
                },
                (err) => DoShowError(notificationService, err),
                () => {
                    $controller.loading = false;
                    loadingIndicatorService.SetLoadingState(false);

                    if (angular.isFunction($controller.onReady))
                        $controller.onReady();
                });
        }
    }
})();